import { Gallery } from "components/Gallery";
import { FileViewLoader } from "components/FileView";
import TooltipLink from "components/Tooltip/TooltipLink";
import { Document } from "types";
import { IndexableDocument } from "hooks/queries/useDocuments";

//TODO replace context data & callback by props #86774
export type FileGalleryProps = {
    documents: IndexableDocument[],
    documentsCount: number,
    pageSize: number,
    pageIndex: number,
    tileSize?: number
    selection?: Document[],
    onPageChange: (newPageIndex: number) => void,
    onSelection?: (selection: Document[]) => void,
    onNameClick?: (fileId: Document) => void,
}

// TODO rename with DocumentGallery
export function FileGallery({ documents, documentsCount, pageSize, pageIndex, tileSize, selection, onNameClick, onSelection, onPageChange }: FileGalleryProps) {

    return <Gallery
        items={documents}
        pageSize={pageSize}
        rowCount={documentsCount}
        selectedItems={selection}
        tileSize={tileSize}
        pageIndex={pageIndex}
        onSelection={onSelection}
        onPageChange={onPageChange}
        bodyComponent={(document: Document) => <FileViewLoader document={document} fileView="tile" displayHeader={false} />}
        footerComponent={getFooterComponent}
    />

    function getFooterComponent(file: Document) {
        return <TooltipLink
            color="inherit"
            href="#"
            variant="body2"
            linkId="filenameLink"
            display="block"
            value={file.title}
            noWrap
            onClick={() => onNameClick && onNameClick(file)} />
    }
}